// Names taken from https://www.color-blindness.com/color-name-hue/
// Requires hex codes as opposed to 'friendly' name (ie. #ffffff instead of white) for scss interpretation
import Resources from '../assets/resources.json';

const {
	BrandColours: RawBrandColours,
	DroughtPhaseColours: RawDroughtPhaseColours,
	FeedbackColours: RawFeedbackColours,
	PebbleStyles: RawPebbleStyles,
} = Resources;

export const BrandColours = Object.freeze(RawBrandColours);
export type BrandColoursType = keyof typeof BrandColours;
export const BrandColourNames = Object.freeze(Object.getOwnPropertyNames(BrandColours) as BrandColoursType[]);

export function isBrandColour(value: string | unknown): value is BrandColoursType {
	return (BrandColourNames as unknown[]).includes(value);
}

export const DroughtPhaseColours = Object.freeze(RawDroughtPhaseColours);
export type DroughtPhaseColoursType = keyof typeof DroughtPhaseColours;
export const DroughtPhaseColourNames = Object.freeze(Object.getOwnPropertyNames(DroughtPhaseColours) as DroughtPhaseColoursType[]);

export type PebbleStylesType = keyof typeof RawPebbleStyles;
export const PebbleStyles = Object.freeze(Object.getOwnPropertyNames(RawPebbleStyles) as PebbleStylesType[]);

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const FeedbackColours = Object.freeze(RawFeedbackColours);
export type FeedbackColoursType = keyof typeof FeedbackColours;
export const FeedbackColoursNames = Object.freeze(Object.getOwnPropertyNames(FeedbackColours) as FeedbackColoursType[]);

export function isFeedbackColour(value: string | unknown): value is FeedbackColoursType {
	return (FeedbackColoursNames as unknown[]).includes(value);
}
